/* ══════════════════════════════════════════════════════════════════════
   IBERLUFFA — FAQ Popup (módulo independiente)
   ──────────────────────────────────────────────────────────────────────
   Auto-se inyecta al cargar. Para abrirlo: window.openFaqPopup() o un
   enlace con onclick="openFaqPopup()". Para eliminarlo: borra este
   archivo y `faq.css`, quita las dos referencias en los .html.
   ══════════════════════════════════════════════════════════════════════ */
(function(){
  'use strict';

  if(document.getElementById('faqModal')) return;

  // ── Preguntas y respuestas ─────────────────────────────────────────
  // Categorías: 'all', 'producto', 'uso', 'envio'
  // i18n: los textos vienen de window.IB_FAQ (inyectado por iberluffa-i18n.liquid
  // según el idioma). El array de abajo queda como fallback en español.
  const FAQS = (window.IB_FAQ && window.IB_FAQ.faqs) || [
    { cat:'producto', q:'¿Qué es una esponja de luffa?',
      a:`<p>Una esponja de luffa es una esponja <strong>100% natural</strong> que se obtiene del interior seco de la calabaza de luffa. En Iberluffa ofrecemos esponjas de luffa de la mejor calidad, que se pueden usar tanto para el cuidado personal como para la limpieza del hogar.</p>
         <p>Además de las esponjas básicas, ofrecemos otros productos como esponjas para ducha, discos exfoliantes y soportes para jabón.</p>` },

    { cat:'uso', q:'¿Para qué puedo usar una esponja de luffa?',
      a:`<p>Nuestras esponjas son perfectas para varios usos:</p>
         <ul>
           <li>Cuidado corporal: exfoliación y masaje</li>
           <li>Lavado de platos y limpieza de superficies</li>
           <li>Soporte para jabón sólido</li>
           <li>Productos para exfoliar la espalda</li>
           <li>Bolsitas para guardar restos de jabón</li>
         </ul>` },

    { cat:'producto', q:'¿La esponja de luffa es ecológica?',
      a:`<p>¡Sí! Nuestras esponjas son <strong>100% biodegradables</strong>, libres de plástico y compostables.</p>
         <p>Garantizamos una <strong>trazabilidad completa</strong>, desde el origen de las materias primas hasta la fabricación, contribuyendo activamente a la protección del medio ambiente.</p>` },

    { cat:'producto', q:'¿Las esponjas de luffa son veganas?',
      a:`<p>Sí, nuestras esponjas están hechas <strong>exclusivamente de fibras vegetales</strong>, por lo que son completamente veganas.</p>
         <p>En Iberluffa apostamos por materiales 100% vegetales en todos nuestros productos para garantizar una opción respetuosa con el medio ambiente.</p>` },

    { cat:'uso', q:'¿Cuánto dura una esponja de luffa?',
      a:`<p>La durabilidad depende del uso y el cuidado. Por lo general dura entre <strong>2 y 3 meses</strong> antes de necesitar un reemplazo.</p>
         <p>Para uso doméstico, como en las esponjas de cocina, puede durar bastante más tiempo si se cuida correctamente.</p>` },

    { cat:'uso', q:'¿Cómo sé que debo reemplazar mi esponja?',
      a:`<p>Reemplaza la esponja si:</p>
         <ul>
           <li>Comienza a <strong>descomponerse</strong> o desfibrarse</li>
           <li>Huele mal incluso después de limpiarla</li>
           <li>Cambia mucho de color o textura</li>
         </ul>` },

    { cat:'uso', q:'¿Cómo cuido mi esponja de luffa?',
      a:`<p>Para que tu esponja dure mucho tiempo, sigue estos consejos:</p>
         <ul>
           <li>Enjuágala bien con agua limpia después de cada uso</li>
           <li>Exprímela y guárdala en un lugar <strong>seco y bien ventilado</strong></li>
           <li>Hiérvela regularmente. Sus fibras resisten al calor sin problema</li>
           <li>Nunca la dejes húmeda: favorece bacterias y moho</li>
         </ul>` },

    { cat:'uso', q:'Mi esponja huele mal, ¿qué puedo hacer?',
      a:`<p>Si la esponja desarrolla mal olor, sumérgela durante unos minutos en <strong>agua caliente</strong> o en una mezcla de <strong>agua y vinagre</strong>.</p>
         <p>Luego, exprímela bien y déjala secar completamente al aire en un lugar ventilado.</p>` },

    { cat:'producto', q:'¿Puedo compostar mi esponja de luffa?',
      a:`<p>Sí, las esponjas de luffa son <strong>100% biodegradables</strong>.</p>
         <p>Cuando termine su vida útil, córtala en trozos pequeños y deposítala en el compost o en el contenedor de residuos orgánicos.</p>` },

    { cat:'uso', q:'¿Cómo uso una esponja de luffa?',
      a:`<p>Antes de usarla por primera vez, <strong>sumérgela en agua tibia</strong> durante unos minutos para que se ablande.</p>
         <p>Una vez ablandada, ya puedes utilizarla con o sin jabón, según prefieras.</p>` },

    { cat:'uso', q:'¿Puedo usar las esponjas de luffa en mi cara?',
      a:`<p>Sí, pero <strong>se recomienda elegir una esponja extra suave</strong> para no irritar la piel sensible del rostro.</p>
         <p>Nuestros discos exfoliantes ofrecen una solución especialmente suave para el cuidado facial.</p>` },

    { cat:'uso', q:'¿Las esponjas de luffa son adecuadas para niños?',
      a:`<p>Sí, pero para pieles sensibles recomendamos una <strong>esponja suave</strong> y un uso delicado.</p>
         <p>En los productos pensados para niños nos aseguramos de que las fibras no sean demasiado rugosas.</p>` },

    { cat:'envio', q:'¿Cuánto tarda el envío?',
      a:`<p>El envío suele tardar entre <strong>5 y 7 días laborables</strong> dentro de Europa.</p>
         <p>Recibirás un email con el seguimiento en cuanto tu pedido salga de nuestro taller.</p>` },

    { cat:'envio', q:'¿A qué países realiza envíos Iberluffa?',
      a:`<p>Actualmente realizamos envíos a <strong>España</strong>, Alemania, Bélgica, Italia, Francia, Portugal y muchos otros países europeos.</p>
         <p>Si tu país no aparece en la lista, no dudes en contactarnos a través del formulario.</p>` },

    { cat:'envio', q:'¿Hay envío gratuito?',
      a:`<p>Sí, ofrecemos <strong>envío gratuito a partir de 60€</strong> en Península y <strong>80€ en EU</strong>.</p>
         <p>Para Islas Baleares el umbral es de 100€.</p>` }
  ];

  const _fcat = (window.IB_FAQ && window.IB_FAQ.cats) || {};
  const FUI = (window.IB_FAQ && window.IB_FAQ.ui) || {};
  const CATS = [
    { id:'all',      label: _fcat.all      || 'Todas' },
    { id:'producto', label: _fcat.producto || 'Producto' },
    { id:'uso',      label: _fcat.uso      || 'Uso y cuidado' },
    { id:'envio',    label: _fcat.envio    || 'Pedidos y envío' }
  ];

  // ── HTML ───────────────────────────────────────────────────────────
  function buildListHTML(filter){
    const items = filter === 'all' ? FAQS : FAQS.filter(f => f.cat === filter);
    if(items.length === 0){
      return '<p style="padding:24px;text-align:center;color:rgba(39,64,1,.6)">' + (FUI.empty || 'No hay preguntas en esta categoría.') + '</p>';
    }
    return items.map((f, i) => `
      <div class="faq-item" data-faq-item>
        <button class="faq-q" type="button" data-faq-toggle>
          <span class="faq-q-num">${String(i+1).padStart(2,'0')}</span>
          <span class="faq-q-text">${f.q}</span>
          <span class="faq-q-icon"><svg viewBox="0 0 24 24"><polyline points="6 9 12 15 18 9"/></svg></span>
        </button>
        <div class="faq-a"><div class="faq-a-inner">${f.a}</div></div>
      </div>
    `).join('');
  }

  function buildPopupHTML(){
    return `
      <div class="faq-head">
        <span class="faq-eyebrow">${FUI.eyebrow || 'Centro de ayuda'}</span>
        <h2 class="faq-title">${FUI.title || 'Preguntas frecuentes'}</h2>
        <p class="faq-sub">${FUI.sub || 'Resolvemos las dudas más comunes sobre nuestras esponjas naturales, su uso, cuidado y envíos.'}</p>
        <button class="faq-close" id="faqCloseBtn" type="button" aria-label="${FUI.close || 'Cerrar'}">
          <svg viewBox="0 0 24 24"><path d="M18 6 6 18M6 6l12 12"/></svg>
        </button>
      </div>
      <div class="faq-cats" id="faqCats">
        ${CATS.map(c => `
          <button type="button" class="faq-cat${c.id === 'all' ? ' faq-on' : ''}" data-cat="${c.id}">${c.label}</button>
        `).join('')}
      </div>
      <div class="faq-body" id="faqBody">
        <div class="faq-list" id="faqList">${buildListHTML('all')}</div>
      </div>
      <div class="faq-foot">
        <p class="faq-foot-txt">${FUI.foot_txt || '¿No encuentras tu respuesta? <strong>Te ayudamos personalmente.</strong>'}</p>
        <a class="faq-foot-cta" href="${(window.IB_LROOT||'')}/pages/contacto">
          ${FUI.contact || 'Contactar'}
          <svg viewBox="0 0 24 24"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
        </a>
      </div>
    `;
  }

  // ── INYECCIÓN ──────────────────────────────────────────────────────
  const bg = document.createElement('div');
  bg.className = 'faq-bg';
  bg.id = 'faqBg';

  const modal = document.createElement('div');
  modal.className = 'faq-modal';
  modal.id = 'faqModal';
  modal.setAttribute('role', 'dialog');
  modal.setAttribute('aria-modal', 'true');
  modal.setAttribute('aria-labelledby', 'faqTitle');
  modal.innerHTML = buildPopupHTML();

  function mount(){
    document.body.appendChild(bg);
    document.body.appendChild(modal);
    bindEvents();
  }

  // ── LÓGICA ─────────────────────────────────────────────────────────
  function openFaqPopup(){
    bg.classList.add('faq-vis');
    modal.classList.add('faq-open');
    if(window.innerWidth <= 768) document.body.style.overflow = 'hidden';
  }
  function closeFaqPopup(){
    bg.classList.remove('faq-vis');
    modal.classList.remove('faq-open');
    document.body.style.overflow = '';
  }
  window.openFaqPopup  = openFaqPopup;
  window.closeFaqPopup = closeFaqPopup;

  function setCategory(catId){
    modal.querySelectorAll('.faq-cat').forEach(b => {
      b.classList.toggle('faq-on', b.getAttribute('data-cat') === catId);
    });
    const list = document.getElementById('faqList');
    if(list) list.innerHTML = buildListHTML(catId);
    bindItems();  // Re-bind acordeón en items nuevos
    const body = document.getElementById('faqBody');
    if(body) body.scrollTop = 0;
  }

  function bindItems(){
    modal.querySelectorAll('[data-faq-toggle]').forEach(btn => {
      btn.addEventListener('click', () => {
        const item = btn.closest('[data-faq-item]');
        if(!item) return;
        // Cerrar todos los demás (acordeón clásico)
        modal.querySelectorAll('[data-faq-item]').forEach(it => {
          if(it !== item) it.classList.remove('faq-open');
        });
        item.classList.toggle('faq-open');
      });
    });
  }

  function bindEvents(){
    const close = document.getElementById('faqCloseBtn');
    if(close) close.addEventListener('click', closeFaqPopup);
    bg.addEventListener('click', closeFaqPopup);

    modal.querySelectorAll('.faq-cat').forEach(btn => {
      btn.addEventListener('click', () => setCategory(btn.getAttribute('data-cat')));
    });

    bindItems();

    document.addEventListener('keydown', e => {
      if(e.key === 'Escape' && modal.classList.contains('faq-open')) closeFaqPopup();
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }
})();
